import React, { useState } from 'react';
import { useShareProperty } from '../../hooks/api/Property/useShareProperty';
import { ShareModal } from '../common/ShareModal';
import { PropertyDataProps } from '../../utility/types';
import { ShareButton } from '../common/ShareButton';

type SharePropertyProps = {
  property: PropertyDataProps;
};

export const ShareProperty = ({ property }: SharePropertyProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { shareProperty } = useShareProperty();

  return (
    <>
      <ShareButton setIsOpen={() => setIsModalOpen(true)} />
      <ShareModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        id={property.id}
        itemToShare={property?.address?.full_address ?? ''}
        onShare={shareProperty}
      />
    </>
  );
};
